import apiFetch from '../../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Bioseguridad/imprimirBioseguridad`, method: 'POST', body: list, token: token})
}
